import { SituationCard } from 'ui/components';

export const SituationCardFeature: React.FC<Umbraco.SituationCard> = ({ properties }) => {
	return <SituationCard {...properties} />;
};
